import { createApp } from 'vue'
import vuetify from './plugins/vuetify'
import { createPinia } from 'pinia'
import router from './router'
import { i18n } from './plugins/i18n'
import MainApp from '@/App.vue'

const app = createApp(MainApp)
const pinia = createPinia()

app.use(vuetify)
app.use(i18n)
app.use(pinia)
app.use(router)

app.mount('#app')
